// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3bLZu","messages":"Chat_messages__1nV-w","dateDivider":"Chat_dateDivider__Tv8Kx"};